import { CONFIRM_TOKEN_USER } from 'root/src/shared/descriptions/endpoints/endpointIds'

import confirmTokenUserSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/confirmTokenUserSchema'

export default {
	[CONFIRM_TOKEN_USER]: {
		payloadSchema: confirmTokenUserSchema,
	},
}
